import { Menu, TopNav } from "@/components";
import { PurchaseCard } from "./PurchaseCard";
import { useParams } from "react-router-dom";
import { Tarif } from "@/widgets";
import { useEffect, useState, useRef } from "react";
import { tg } from "@/constants/telegram";
import { useAddUserActionMutation } from "@/store/usersApi";
import { useGetServicesMutation } from "@/store";
import { useYandexMetrika, GOALS } from "@/hooks/useYandexMetrika";
import { useAppSelector } from "@/shared/hooks";

export const PurchasePage = () => {
  const { id } = useParams();
  const currentTarifId = Number(id) || 1;
  const [currentTarif, setCurrentTarif] = useState<Tarif | null>(null)
  const [addUserAction] = useAddUserActionMutation();
  const [getServices] = useGetServicesMutation();
  const { trackAction } = useYandexMetrika();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const hasSentAction = useRef(false);

  useEffect(() => {
    const getTarif = async () => {
      const hasAuth = tg?.initData || isAuthenticated || localStorage.getItem("access_token");
      if (hasAuth && currentTarifId) {
        try {
          const response = await getServices().unwrap()
          const { services } = response
          setCurrentTarif(services.find(s => s.id === currentTarifId ) ?? null)
        } catch (error) {
          console.error("Ошибка загрузки тарифа:", error);
        }
      }  
    }

    getTarif();
  }, [getServices, isAuthenticated, currentTarifId]);

  useEffect(() => {
    if (hasSentAction.current || !currentTarif) return;
    
    const sendAction = async () => {
      const hasAuth = tg?.initData || isAuthenticated || localStorage.getItem("access_token");
      if (hasAuth && currentTarif) {
        try {
          await addUserAction({
            action: `Выбрал тариф ${currentTarif.title}`
          }).unwrap();
          
          trackAction(GOALS.ACTION_TARIFF_SELECTED, {
            tarifId: currentTarif.id,
            tarifTitle: currentTarif.title,
            cost: currentTarif.cost,
            isTrial: currentTarif.is_trial
          });
          
          hasSentAction.current = true;
        } catch (error) {
          console.error("Ошибка при отправке действия пользователя:", error);
        }
      }
    };

    sendAction();
  }, [currentTarif, addUserAction, isAuthenticated, trackAction]);



  return (
    <div data-testid="PurchasePage">
      <TopNav
        linkPath={"/subscription"}
        handleSetActivePage={() => null}
        title={"Оформление подписки"}
      />
      <div className="py-6">
        {currentTarif ? (
          <div className="py-6">
            <PurchaseCard tarif={currentTarif} />
          </div>
        ) : (
          <div className="py-6 text-center">
            <p>Загрузка...</p>
          </div>
        )}
      </div>
      <Menu active={2} />
    </div>
  );
};

